module.exports = [{"name":"Eurasian Eagle-Owl","name_cs":"Výr velký","filename":"Eurasian Eagle-Owl - Bubo bubo bubo.mp3","cc":"https://www.xeno-canto.org/463103"},{"name":"Mallard","name_cs":"Kachna divoká","filename":"Mallard - Anas platyrhynchos.mp3","cc":"https://www.xeno-canto.org/505439"},{"name":"Rook","name_cs":"Havran","filename":"Rook - Corvus frugilegus.mp3","cc":"https://www.xeno-canto.org/490906"},{"name":"Yellow-legged Gull","name_cs":"Racek středomořský","filename":"Yellow-legged Gull - Larus michahellis.mp3","cc":"https://www.xeno-canto.org/500914"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/levels/level_1.json
// module id = 36
// module chunks = 0